import { render } from "./BaseLayout.vue?vue&type=template&id=9a512a0a&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=9a512a0a&lang=less&scoped=true"
import "./BaseLayout.vue?vue&type=style&index=1&id=9a512a0a&lang=less"

import exportComponent from "/home/jenkins/.jenkins/workspace/172.16.20.198.leelen-mall-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a512a0a"]])

export default __exports__